module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_8003.7611155c.png";